import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  WalletModalProvider,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useWallet } from "@solana/wallet-adapter-react";
const PhantomConnectInfo = (props, context) => {
  const { connected, wallet } = useWallet();

  const { closeConnectWallet } = props;

  const prevConnectedRef = React.useRef(connected);

  const ctaForState = wallet
    ? context.t("Connect with Phantom Wallet")
    : context.t("Select Phantom Wallet");

  useEffect(() => {
    if (!prevConnectedRef.current && connected) {
      closeConnectWallet && closeConnectWallet();
    }
    prevConnectedRef.current = connected;
  }, [connected, closeConnectWallet]);
  return (
    <div className="text-center d-flex flex-column">
      <p className="h4 text-center fw-bold mb-5">
        {context.t("Connect with Phantom")}
      </p>
      <div className="text-center d-flex justify-content-center">
        <WalletModalProvider>
          <WalletMultiButton>{ctaForState}</WalletMultiButton>
        </WalletModalProvider>
      </div>
      <p className="my-4">
        {context.t(
          "Phantom is a common and often used wallet that enables users to access the Web 3 ecosystem of decentralized applications."
        )}
      </p>
      <p className="mb-5">
        {context.t("Please use your existing Phantom wallet.")}
      </p>
      <p className="small text-start">
        <strong>{context.t("Want to learn more about this wallet?")}</strong>
        <br />
        {context.t("Learn how to install and setup this wallet on")}{" "}
        <a
          href="https://phantom.com/"
          target="_blank"
          rel="noreferrer"
          className="mt-5"
        >
          phantom.com <FaExternalLinkAlt />
        </a>
        .
      </p>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
PhantomConnectInfo.contextTypes = {
  t: PropTypes.func,
};

PhantomConnectInfo.propTypes = {
  closeConnectWallet: PropTypes.func,
};

export default PhantomConnectInfo;
